import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";

// Lazy-load all non-homepage routes to reduce initial bundle size
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const ProfileSetup = lazy(() => import("./pages/ProfileSetup"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const HoroscopePage = lazy(() => import("./pages/HoroscopePage"));
const CompatibilityPage = lazy(() => import("./pages/CompatibilityPage"));
const TarotPage = lazy(() => import("./pages/TarotPage"));
const BirthChartPage = lazy(() => import("./pages/BirthChartPage"));
const AiAstrologerPage = lazy(() => import("./pages/AiAstrologerPage"));
const SoulmateFinder = lazy(() => import("./pages/SoulmateFinder"));
const LuckyDay = lazy(() => import("./pages/LuckyDay"));
const CosmicTimeline = lazy(() => import("./pages/CosmicTimeline"));
const LovePredictor = lazy(() => import("./pages/LovePredictor"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AdminSubmissions = lazy(() => import("./pages/AdminSubmissions"));
const AdminSubscribersReport = lazy(() => import("./pages/AdminSubscribersReport"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const SpiritualShop = lazy(() => import("./pages/SpiritualShop"));
const EbookThankYou = lazy(() => import("./pages/EbookThankYou"));
const CosmicEnergyThankYou = lazy(() => import("./pages/CosmicEnergyThankYou"));
const SubscriptionThankYou = lazy(() => import("./pages/SubscriptionThankYou"));
const ChakraTreeThankYou = lazy(() => import("./pages/ChakraTreeThankYou"));
const EnergyPyramidThankYou = lazy(() => import("./pages/EnergyPyramidThankYou"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile-setup" element={<ProfileSetup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/horoscope" element={<HoroscopePage />} />
            <Route path="/compatibility" element={<CompatibilityPage />} />
            <Route path="/tarot" element={<TarotPage />} />
            <Route path="/birth-chart" element={<BirthChartPage />} />
            <Route path="/ai-astrologer" element={<AiAstrologerPage />} />
            <Route path="/soulmate" element={<SoulmateFinder />} />
            <Route path="/lucky-day" element={<LuckyDay />} />
            <Route path="/cosmic-timeline" element={<CosmicTimeline />} />
            <Route path="/love-predictor" element={<LovePredictor />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/submissions" element={<AdminSubmissions />} />
            <Route path="/admin/subscribers" element={<AdminSubscribersReport />} />
            <Route path="/shop" element={<SpiritualShop />} />
            
            <Route path="/ebook/thank-you" element={<EbookThankYou />} />
            <Route path="/subscription/thank-you" element={<SubscriptionThankYou />} />
            <Route path="/ebook/cosmic-energy/thank-you" element={<CosmicEnergyThankYou />} />
            <Route path="/shop/chakra-tree/thank-you" element={<ChakraTreeThankYou />} />
            <Route path="/shop/energy-pyramid/thank-you" element={<EnergyPyramidThankYou />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
